import React, {FC} from "react";
import {ConditionManaged} from "@types";
import {FormattedDaysAgo} from "@components/formatted.tsx";

export type ManagedProps = {
    condition: ConditionManaged;
};

const MANAGED_DETAILS: Record<
    string,
    { description: string; venue: string, risk: string; updated: string; model: string, note: string }
> = {
    PUMP_FUN_MANAGED_KITTY_PAWS: {
        description: "Prioritizes scam prevention with strict criteria, ideal for cautious traders who value stability over moonshots.",
        venue: "pumpfun",
        risk: "Low",
        updated: "2025-04-09T00:00:00.000Z",
        model: "AI_GRK_V1",
        note: "Most pump.fun tokens eventually rug — this rule tries to avoid them as best as possible."
    },
    PUMP_FUN_MANAGED_WHISKER_TWITCH: {
        description: "Balances growth and safety, appealing to users who want decent returns without diving into full degen territory.",
        venue: "pumpfun",
        risk: "Medium",
        updated: "2025-04-09T00:00:00.000Z",
        model: "AI_GRK_V1",
        note: "Most pump.fun tokens eventually rug — this rule aims for a reasonable middle ground."
    },
    PUMP_FUN_MANAGED_POUNCE_PREDATOR: {
        description: "Caters to “degens” chasing 100x gems, accepting higher scam risk for the chance at massive gains. Fits pump.fun’s high-risk, high-reward energy.",
        venue: "pumpfun",
        risk: "High",
        updated: "2025-04-09T00:00:00.000Z",
        model: "AI_GRK_V1",
        note: "Most pump.fun tokens eventually rug — this rule embraces the chaos."
    }
};

export const Managed: FC<ManagedProps> = React.memo(({condition}) => {
    const managed = condition.managed;
    const details = MANAGED_DETAILS[managed];

    return (
        <div
            className="w-full max-w-2xl mx-auto rounded-3xl border shadow-2xl p-8 backdrop-blur-md space-y-6"
        >
            <h2 className="text-center text-orange-600 font-bold text-xl tracking-tight drop-shadow-sm">
                Managed By AI
            </h2>

            <div className="text-lg sm:text-base text-orange-200 space-y-2 leading-relaxed">
                <p>{details.description}</p>

                <p className="pt-4 flex justify-between">
                    <span>Risk Level:</span>
                    <span className="font-semibold">{details.risk}</span>
                </p>

                <p className="flex justify-between">
                    <span>Venue:</span>
                    <span className="font-semibold">{details.venue}</span>
                </p>

                <p className="flex justify-between">
                    <span>Model:</span>
                    <span className="font-semibold">{details.model}</span>
                </p>

                <p className="flex justify-between">
                    <span>Last Updated:</span>
                    <FormattedDaysAgo className={"font-semibold"} date={new Date(details.updated)}/>
                </p>
            </div>

            <div className="text-orange-500 font-medium text-center italic">
                {details.note}
            </div>
        </div>
    )
});